import { render, staticRenderFns } from "./GVueTable.vue?vue&type=template&id=3aeb1d96&"
import script from "./GVueTable.vue?vue&type=script&lang=js&"
export * from "./GVueTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports